export type RunFlags = {
  acceptedHelp: boolean;
  helpersJoined: number;
  deaths: number;
};

/**
 * Automata Ending E style: one hit = death.
 * No mid-flight spare stock — die → help offer or restart.
 */
export class RunState {
  invuln = 0;
  alive = true;
  cleared = false;
  elapsed = 0;
  flags: RunFlags = {
    acceptedHelp: false,
    helpersJoined: 0,
    deaths: 0,
  };

  /** One contact ends the flight unless invulnerable. */
  hit(): "dead" | "ignored" {
    if (this.invuln > 0 || !this.alive) return "ignored";
    this.flags.deaths += 1;
    this.alive = false;
    return "dead";
  }

  tickInvuln(dt: number): void {
    if (this.invuln > 0) this.invuln = Math.max(0, this.invuln - dt);
  }

  markClear(): void {
    this.cleared = true;
    this.alive = false;
  }

  /**
   * Brief invuln only (Ending E style).
   * Not a life stock — after this expires, one hit = death again.
   */
  grantIFrames(seconds: number): void {
    this.alive = true;
    // Replace, don't stack (stacking felt like unlimited lives)
    this.invuln = seconds;
  }
}
